module.exports = __webpack_public_path__ + "static/media/homeowner6-2.c908c42e.png";